<template>
    <div>
        <template v-if="config.type == 'money'">
            <span>¥</span>{{toThousands(value[config.field])}}
        </template>
        <template v-else-if="config.type == 'number'">
            {{toThousands(value[config.field])}}
        </template>
        <template v-else-if="config.type == 'percentage'">
            <!--  百分比，需要返回一个 proportion, 为1代表增长，0为跌 -->
            <template v-if="isShowIcon">
                <Icon type="ios-play" :class="value.proportion > 0 ? 'ly-summary-up' : 'ly-summary-down'" />
            </template>
            {{value[config.field]}}%
        </template>
        <template v-else-if="config.type == 'progress'">
            <Progress :percent="value[config.field]" hide-info />
        </template>
    </div>
</template>
<script>
    /**
     * 数据显示控制
     */
    export default {
        props: {
            value: { // 显示的值
                type: [Object, String],
                default: () => new Object()
            },
            config: { // 对应的配置
                type: Object,
                default: () => new Object()
            },
            isShowIcon: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            toThousands(num) {
                return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
            }
        }
    }
</script>
<style>
    .ly-summary-up {
        color: #ed4014;
        transform:rotate(-90deg); 
    }
    .ly-summary-down {
        color: #19be6b;
        transform:rotate(90deg);
    }
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/summary-panel/src/show.vue